// Logo firmy: ořez prázdných okrajů při nahrání a velikost v PDF podle tvaru.
// Výpočet velikosti je stejný jako na serveru (backend/logo.py) — náhled
// v Nastavení tak sedí s PDF.

export const TITUL = [72, 340, 96];      // základ px, max. šířka, max. výška
export const HLAVICKA = [34, 200, 44];

export function rozmerLoga(pomer, [zaklad, maxW, maxH], velikostPct = 100) {
  const p = Math.min(Math.max(Number(pomer) || 1.75, 0.25), 12);
  let w = zaklad * (velikostPct || 100) / 100 * p ** 0.7;
  let h = w / p;
  if (w > maxW) { w = maxW; h = maxW / p; }
  if (h > maxH) { w = maxH * p; h = maxH; }
  return { w: Math.round(w), h: Math.round(h) };
}

const nacist = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = () => reject(new Error("Obrázek se nepodařilo načíst."));
  img.src = src;
});

export async function pomerObrazku(src) {
  const img = await nacist(src);
  return img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 1.75;
}

/**
 * Ořízne průhledné a bílé okraje a zmenší logo na max. 1200 × 600 px (PNG).
 * Bez okrajů se logo v PDF vykreslí tak velké, jak má (prázdné místo okolo by
 * ho zmenšilo). Tvar loga zůstane — čtverec, na výšku i na šířku.
 */
export async function oriznoutLogo(src) {
  const img = await nacist(src);
  const k = Math.min(1, 2400 / Math.max(img.naturalWidth, img.naturalHeight));
  const W = Math.max(1, Math.round(img.naturalWidth * k)), H = Math.max(1, Math.round(img.naturalHeight * k));
  const c = document.createElement("canvas"); c.width = W; c.height = H;
  const ctx = c.getContext("2d"); ctx.drawImage(img, 0, 0, W, H);
  const d = ctx.getImageData(0, 0, W, H).data;
  const prazdny = (i) => d[i + 3] < 16 || (d[i] > 245 && d[i + 1] > 245 && d[i + 2] > 245);
  let x0 = W, y0 = H, x1 = -1, y1 = -1;
  for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
    if (!prazdny((y * W + x) * 4)) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
  }
  if (x1 < 0) { x0 = 0; y0 = 0; x1 = W - 1; y1 = H - 1; }   // celé prázdné — nechat, jak je
  const ow = x1 - x0 + 1, oh = y1 - y0 + 1;
  let s = Math.min(1, 1200 / ow, 600 / oh);
  for (;;) {
    const v = document.createElement("canvas");
    v.width = Math.max(1, Math.round(ow * s)); v.height = Math.max(1, Math.round(oh * s));
    v.getContext("2d").drawImage(c, x0, y0, ow, oh, 0, 0, v.width, v.height);
    const out = v.toDataURL("image/png");
    if (out.length < 780 * 1024 || s < 0.2) return out;   // server bere max. 800 kB
    s *= 0.75;
  }
}
